import "babel-polyfill";
import "./configure";
import "./main.css";
import { loadPolyfills } from "./polyfills";

loadPolyfills().then(() =>
  import(
    /* webpackChunkName: "app-main" */
    "./bootstrapper"
  ).then(({ bootstrapApplication }) => {
    // eslint-disable-next-line
    bootstrapApplication().catch(console.error);
  })
);
